
export function TransferError(json) {
	this.status = json.status;
	this.timestamp = json.timestamp;
	this.path = json.path;
	this.error = json.error;
	this.message = json.message!==undefined ? json.message : json.exception;
}
